const actions = {
  STRIPE_INVITATION_BEGIN: 'STRIPE_INVITATION_BEGIN',
  STRIPE_INVITATION_SUCCESS: 'STRIPE_INVITATION_SUCCESS',
  STRIPE_INVITATION_ERR: 'STRIPE_INVITATION_ERR',
  STRIPE_DISCONNECT_BEGIN: 'STRIPE_DISCONNECT_BEGIN',
  STRIPE_DISCONNECT_SUCCESS: 'STRIPE_DISCONNECT_SUCCESS',
  STRIPE_DISCONNECT_ERR: 'STRIPE_DISCONNECT_ERR',

  inviteStripeBegin: () => {
    return {
      type: actions.STRIPE_INVITATION_BEGIN,
    };
  },
  inviteStripeSuccess: (data) => {
    return {
      type: actions.STRIPE_INVITATION_SUCCESS,
      data,
    };
  },

  inviteStripeErr: (err) => {
    return {
      type: actions.STRIPE_INVITATION_ERR,
      err,
    };
  },

  disconnectStripeBegin: () => {
    return {
      type: actions.STRIPE_DISCONNECT_BEGIN,
    };
  },
  disconnectStripeSuccess: (data) => {
    return {
      type: actions.STRIPE_DISCONNECT_SUCCESS,
      data,
    };
  },

  disconnectStripeErr: (err) => {
    return {
      type: actions.STRIPE_DISCONNECT_ERR,
      err,
    };
  },
};
export default actions;
